import { Maybe } from "./types/maybe.ts";

export default function formatDateString(dateString: Maybe<string>): string {
  if (dateString == null || dateString.trim() === "") {
    return "-";
  }

  const date = new Date(dateString);

  if (date == null) {
    return "-";
  }

  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}
